export default "__VITE_ASSET__DxIlX9kN__"